<template>
    <main-content>
        <div class="bg-white shadow-sm rounded p-4">
            <auto-settlement-form :form_data="form_data"
                                  :password="password"
                                  :setting_status="setting_status"
                                  :form_meta_data="form_meta_data"
                                  :on_submit="sendCode"
                                  @settlement="settlement"            >
            </auto-settlement-form>
        </div>
    </main-content>
</template>

<script>
    import AutoSettlementForm from './components/auto-settlement-form'
    import mainContent from '@/components/main-content'
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";
    import Inputmask from "inputmask";

    export default {
        components: {
            AutoSettlementForm,
            mainContent,
        },
        data() {
            return {
                password: {
                    value: '',
                },
                setting_status: {
                    value: false,
                },
                form_data: [
                    {
                        percent: 0,
                        destination_number: '',
                        destination_firstname: '',
                        destination_lastname: '',
                    },
                ],
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.submit_changes'),
                },
            };
        },
        mounted() {
            walletService.getAutoSettlementSettings(this.$route.params.hashid).then(res => {
                this.setting_status.value = res.data.data.setting_status;

                if (res.data.data.transfers.length > 0) {
                    this.form_data = res.data.data.transfers;
                }
            });
        },
        methods: {
            masked() {
                setTimeout(() => {
                    document.getElementById("google_authenticator_code") &&
                    Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
                }, 100);
            },
            sendCode() {

                if (!this.form_data.should_two_factor_settlement) {
                    this.settlement()
                    return;
                }

                let form = $('#submit_form');

                form.validate({
                    rules: {
                        password: {
                            required: true,
                        },
                    },
                });

                if (! form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;
                let percent = 0;

                for (let transfer of this.form_data)
                {
                    if (Math.floor(transfer.percent) < 1) {
                        this.showMsg(form, 'danger', i18n.t('wallets.error.min_percent_is_1_percent'));
                        return;
                    }

                    percent += Math.floor(transfer.percent);
                }

                if (percent > 100) {
                    this.showMsg(form, 'danger', i18n.t('wallets.error.maximum_total_percent_is_100_percent'));
                    return;
                }

                let params = {
                    wallet_id: this.$route.params.hashid,
                    two_factor_type: this.form_data.two_factor_type,
                    password: this.password.value,
                };

                walletService.sendVerificationCode(params).then(response => {

                    this.form_data.two_factor_type = response.data.data.two_factor_type;
                    this.masked();
                    $('#approve_modal').modal('show');
                    this.toastr.success(response.data.message);

                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },

            settlement() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        password: {
                            required: true,
                        },
                    },
                });

                if (! form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let percent = 0;

                for (let transfer of this.form_data)
                {
                    if (Math.floor(transfer.percent) < 1) {
                        this.showMsg(form, 'danger', i18n.t('wallets.error.min_percent_is_1_percent'));
                        return;
                    }

                    percent += Math.floor(transfer.percent);
                }

                if (percent > 100) {
                    this.showMsg(form, 'danger', i18n.t('wallets.error.maximum_total_percent_is_100_percent'));
                    return;
                }

                let params = {
                    transfers: this.form_data,
                    password: this.password.value,
                    otp: !this.form_data.otp ? '': this.toEng(this.form_data.otp),
                    two_factor_type: !this.form_data.two_factor_type ? '': this.form_data.two_factor_type,
                    should_two_factor_settlement: this.form_data.should_two_factor_settlement,
                    setting_status: this.setting_status.value,
                };

                walletService.setAutoSettlementSettings(params, this.$route.params.hashid).then(response => {
                    $('#approve_modal').modal('hide');
                    this.$router.push('/wallets');
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
        },
    }
</script>
